// src/utils/confirmar.js
// ============================================================================
// Modal de CONFIRMACIÓN global — reemplaza window.confirm() arcaico.
// ----------------------------------------------------------------------------
// Es async: devuelve una Promise<boolean>. Se usa con await, igual de simple
// que window.confirm pero fino y tokenizado (usa el <Modal> global).
//
// Uso:
//   import confirmar from '../../utils/confirmar';
//   const ok = await confirmar({
//     titulo: 'Anular pedido',
//     mensaje: '¿Seguro que querés anular el pedido FPC1-123? No se puede deshacer.',
//     textoConfirmar: 'Sí, anular',
//     peligro: true,            // pinta el botón de confirmar en rojo
//   });
//   if (!ok) return;
//
// El host <ConfirmHost> (montado 1 vez en App.js) escucha y renderiza el modal.
// Si el host no está montado (caso raro), cae a window.confirm como respaldo.
// ============================================================================

let host = null;

export function _registrarHost(fn) {
  host = fn;
  return () => { if (host === fn) host = null; };
}

export default function confirmar(opciones = {}) {
  return new Promise((resolve) => {
    if (!host) {
      // Respaldo: si por alguna razón el host no está montado, no dejamos
      // colgada la decisión — usamos el confirm nativo.
      // eslint-disable-next-line no-alert
      resolve(window.confirm(opciones.mensaje || '¿Confirmar la acción?'));
      return;
    }
    host({ ...opciones, resolver: resolve });
  });
}
